export class UserFile {
    Id?: string;
    Type?: number;
    Name = '';
    BoardClass?: number;
    BoardId?: number;
    Content?: any;
    SiteId?: number;
    MimeType?: string;
    CreatedAt?: Date;
    UpdatedAt?: Date;
}
